import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=bace73c0&lang=pug&"
import script from "./TopMenu.vue?vue&type=script&lang=js&"
export * from "./TopMenu.vue?vue&type=script&lang=js&"
import style0 from "./TopMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bace73c0')) {
      api.createRecord('bace73c0', component.options)
    } else {
      api.reload('bace73c0', component.options)
    }
    module.hot.accept("./TopMenu.vue?vue&type=template&id=bace73c0&lang=pug&", function () {
      api.rerender('bace73c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TopMenu.vue"
export default component.exports